import { render, staticRenderFns } from "./OrderResultsUser.vue?vue&type=template&id=62db2762&"
import script from "./OrderResultsUser.vue?vue&type=script&lang=js&"
export * from "./OrderResultsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports